export function GDRmarker() {
  return (
    <i
      style={{
        display: 'inline-block',
        width: 32,
        height: 32,
      }}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        stroke='#fff'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-landmark-icon lucide-landmark'
      >
        <path
          d='M16 2c-6.075 0-11 4.925-11 11 0 8.25 11 17 11 17s11-8.75 11-17c0-6.075-4.925-11-11-11z'
          fill='var(--airc-ui__colors-accent-500)'
          stroke='none'
          transform='translate(16, 16) scale(1.08) translate(-16, -16)'
        />
        <g transform='translate(4, 4) translate(12, 12) scale(0.86) translate(-12, -12) translate(0, -3.5)'>
          <path d='M10 18v-7' />
          <path d='M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z' />
          <path d='M14 18v-7' />
          <path d='M18 18v-7' />
          <path d='M3 22h18' />
          <path d='M6 18v-7' />
        </g>
      </svg>
    </i>
  )
}
